import { IPageInfo } from './pageInfo';
import { IndexModuleType } from '../enums';

export enum IndexCardSize {
    BIG = 1,
    NORMAL = 2,
    SMALL = 3
}

// @see https://wiki.umu.work/pages/viewpage.action?pageId=21890707
export interface IModule {
    id: string;
    title: string;
    type: IndexModuleType;
    show_num: number;
    show_type: IndexCardSize;
    program_id?: number;
    jump?: string;
    index?: number;
    position?: 1 | 2;
    bg_color?: string;
    txt_color?: string;
    btn_color?: string;
    title_color?: string;
    content_color?: string;
    obj_id?: string;
    obj_info?: {
        content: INavItem[] | any;
    };
    index_in_total?: number; // index_in_total，表示该卡片在卡片列表中的序号
    index_in_page?: number; // 表示该卡片在当前卡片列表也中的序号
    jump_position?: string; // 表示该卡片需要跳转的位置
    show_index_in_total?: number; // 表示该卡片在可展示卡片列表中的序号
    max_position?: number; // 表示该卡片最大可跳转的位置
    is_stable?: number; // 是否不可移动的模块（不可展示的或者固定位置的）
    ext_info?: string; // 额外信息，由 json 字符串组成
    course_category_id?: string;
    session_type?: string;
    time_range?: string;
}

// 轮播图
export interface ICarousels {
    list: Array<{
        title: string;
        head_img: string;
        share_url: string;
        pic_url: string;
        outer_url: string;
    }>;
    page_info: IPageInfo;
    isLoading: boolean;
    type: IndexModuleType.CAROUSE;
}

export enum NavType {
    task = 1,
    chat = 2,
    comments = 3,
    leaderboard = 4,
    registeredCourse = 5,
    class = 7,
    courseCategory = 8,
    learningHistory = 9,
    favorite = 20,
    UShow = 10001,
    chatbot = 26
}

// 首页导航
export interface INavItem {
    id: number;
    show_index: number;
    icon: string;
    jump: string;
    item_type: NavType;
    auth: number;
    title: string;
    is_show: boolean;
    notificationCnt?: number; // im 消息数
    title_i18n?: { [lang: string]: string };
}

enum TASK_TYPE {
    COURSE = 0,
    PROGRAM = 1
}

// 学习任务
export interface ITask {
    stage_num: number;
    group_num: number;
    learn_status: number;
    finish_time: number;
    due_time: number;
    over_due: number;
    program_id: number;
    group_id: string;
    session_num: number;
    task_type: TASK_TYPE;
    title: string;
    show_pic: string;
    teacher_id: number;
    teacher_name: string;
    teacher_avatar: string;
    share_qrc: string;
    share_card_view: string;
    participate: string;
    assign_url: string;
    teacher_avatar_arr: string[];
    unfinish_task_num: number;
    finish_count: number;
    finish_ratio: number;
    session_url: string;
    expired_access: number;
}

export interface IProgramCourse {
    group_id: number;
    finish_ratio: number;
    learn_status: number;
    session_url: string;
    session_num: number;
    head_img: string;
    title: string;
    participate_num: number;
    share_url: string;
    obj_id: number;
    obj_type: string;
    share_qrc: string;
    share_card_view: string;
    lock: number;
    access_code: string;
}

export interface IProgram {
    list: IProgram[];
    page_info: IPageInfo;
    isLoading: boolean;
}

export interface IPrograms {
    list: Array<{ programId: number }>;
    page_info: IPageInfo;
    isLoading: boolean;
    courses: {
        [name: string]: {
            list: IProgramCourse[];
            page_info: IPageInfo;
            isLoading: boolean;
        };
    };
}

export interface IHomepageStyle {
    id: number;
    type: number;
    title: string;
    is_show_lunbo: 0 | 1;
    is_shownav: 0 | 1;
    is_showtask: 0 | 1;
    is_showranks: 0 | 1;
    is_showprofile: 0 | 1;
    is_show_ai_recommend: 0 | 1;
    is_show_ai_recommend_course: 0 | 1;
    is_use: number;
    is_default: number;
    update_ts: number;
    modules: IModule[];
}

export interface ICourseHomePage {
    group_id: string;
    im_rid: number;
    im_url: string;
    finish_ratio: number;
    learn_status: number;
    session_url: string;
    session_num: string;
    head_img: string;
    title: string;
    participate_num: string;
    obj_id: string;
    obj_type: string;
    share_url: string;
    share_qrc: string;
    share_card_view: string;
    access_code: string;
}

export interface IHomePageRes<T> {
    page_info: IPageInfo;
    list: T[];
    type: IndexModuleType;
}

export enum RANK_TYPE {
    LIKE_LEARN = 9,
    STAR_NUM = 10,
    LIKE_NUM = 11,
    POINT_NUM = 15
}
